import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    text: 'Hacía keto hace meses pero siempre terminaba repitiendo las mismas 3 recetas. En la primera semana ya había probado 5 platos distintos que no conocía. Mi marido no podía creer lo rico que era todo.',
    name: 'María L.',
    location: 'Córdoba'
  }, {
    text: 'En 10 días bajé 2 kilos y ya no siento esa hinchazón de después de comer. Lo mejor es que cocino en 15 minutos.',
    name: 'Carolina S.',
    location: 'CABA'
  }, {
    text: 'Hacía keto pero dos o tres veces por semana terminaba pidiendo delivery porque no sabía qué más cocinar. Con este recetario dejé de improvisar. Ahora tengo 40 opciones y nunca más caí en el delivery por no tener ideas.',
    name: 'Patricia R.',
    location: 'Rosario'
  }, {
    text: 'Bajé 4 kilos en las dos primeras semanas. Lo mejor fue que no pasé hambre ningún día. Los snacks me salvaron las tardes. El bono de untables es un plus enorme.',
    name: 'Valentina A.',
    location: 'Santa Fe'
  }, {
    text: 'Trabajo todo el día y tengo poco tiempo. Estas recetas son en serio rápidas. El plan de 14 días me ordenó la semana y dejé de improvisar. Recomendable 100%.',
    name: 'Natalia M.',
    location: 'Chaco'
  }, {
    text: 'Trabajo todo el día y cuando llegaba a casa lo último que quería era ponerme a pensar qué cocinar. Siempre terminaba comiendo cualquier cosa. Ahora abro el recetario, elijo una receta y en 20 minutos tengo algo rico y keto listo. No puedo creer que sea tan fácil.',
    name: 'Laura C.',
    location: 'La Plata'
  }];
  return <section className="bg-white py-16 px-4 md:py-24" data-id="element-292">
      <div className="max-w-[1000px] mx-auto" data-id="element-293">
        <div className="text-center mb-12" data-id="element-294">
          <div className="inline-block bg-gray-100 text-gray-800 font-bold text-xs px-4 py-1.5 rounded-full mb-4" data-id="element-295">
            👥 TESTIMONIOS
          </div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-gray-900" data-id="element-296">
            Resultados reales de personas que{' '}
            <span className="text-[#00A86B]" data-id="element-297">ya lo tienen</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-298">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-[#F5F5F5] p-6 rounded-2xl flex flex-col h-full" data-id="element-299">
              <div className="flex text-[#F59E0B] mb-4" data-id="element-300">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-301" />)}
              </div>
              <p className="text-gray-600 italic text-sm leading-relaxed mb-6 flex-1" data-id="element-302">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 mt-auto" data-id="element-303">
                <div className="w-10 h-10 rounded-full bg-[#00A86B]/20 flex items-center justify-center text-[#00A86B] font-bold" data-id="element-304">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-305">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-306">{t.name}</p>
                  <p className="text-gray-500 text-xs" data-id="element-307">{t.location}</p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}